import { DataPoints } from "../DataPoints";
import {
  DEFAULT_HEIGHT,
  DEFAULT_WIDTH,
  QuadrantAxisProps,
  calculateAverage,
  getLinesPosition,
} from "../shared";
import "./style.scss";

export const QuadrantAxis: React.FC<QuadrantAxisProps> = ({
  points,
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
  xTitle,
  yTitle,
  bgColor = "var(--fl-color-background)",
}) => {
  const { x: refX, y: refY } = calculateAverage(points);
  const { x: referenceXPos, y: referenceYPos } = getLinesPosition(
    refX,
    refY,
    width,
    height
  );

  return (
    <div className="quadrant-axis-container">
      <div className="quadrant-axis">
        <div
          className="chart-area"
          style={{
            width: `${width}px`,
            height: `${height}px`,
          }}
        >
          <DataPoints points={points} width={width} height={height} />
          <div className="axis x-axis" />
          <div className="axis y-axis" />

          <div
            className="reference-line horizontal"
            style={{
              top: `${referenceYPos}px`,
              width: `${referenceXPos}px`,
            }}
          />
          <div
            className="axis-label y-label result"
            style={{
              top: `${referenceYPos}px`,
            }}
          >
            {Math.round(refY * 100)}%
            <span className="chevron right" style={{ background: bgColor }} />
          </div>
          <div className="axis-label y-label start">0%</div>
          <div className="axis-label y-label end">100%</div>
          <div
            className="reference-line vertical"
            style={{
              left: `${referenceXPos}px`,
              height: `${height - referenceYPos}px`,
              bottom: "0px",
            }}
          />
          <div
            className="axis-label x-label result"
            style={{
              left: `${referenceXPos}px`,
            }}
          >
            <span className="chevron up" style={{ background: bgColor }} />
            {Math.round(refX * 100)}%
          </div>
          <div className="axis-label x-label end">100%</div>
        </div>

        <div className="axis-title y-title">{yTitle}</div>
        <div className="axis-title x-title">{xTitle}</div>
      </div>
    </div>
  );
};
